import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { EmailSubmitted, IStrapiDocument } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-email-submitted',
    templateUrl: './email-submitted.component.html',
    styleUrls: ['./email-submitted.component.scss'],
    imports: [NgIf],
})
export class EmailSubmittedComponent extends PageComponent implements OnInit {
  public override pageData: EmailSubmitted = <EmailSubmitted>{};

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    const params = {
      populate:{
        web_image: {
          populate: '*'
        }
      }
    }

    this.strapi
      .getDocumentByUID('email-submitted', 'email-submitted', params)
      .subscribe((data: IStrapiDocument<EmailSubmitted>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.cdr.detectChanges();
      });
  }

  protected override parsePageData(page: EmailSubmitted): void {
    super.parsePageData(page);

    this.pageData = page;
  }
}
